import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@devinforius/super-compos-17';
import { NgxSpinnerService } from 'ngx-spinner';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { Global_Class } from 'src/app/shared/models/global';
import * as async from 'async';
import moment from 'moment';
import { LabelValue } from 'src/app/shared/models/labelvalue';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'underscore';
import { Meeting, MeetingPaginated } from 'src/app/shared/models/meeting';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';

@Component({
  selector: 'app-point-report',
  templateUrl: './point-report.component.html',
  styleUrls: ['./point-report.component.scss'],
})
export class PointReportComponent implements OnInit {
  public formReportPoint = new UntypedFormGroup({
    files: new UntypedFormControl(true),
    keepPointRedacteur: new UntypedFormControl(true),
    duplicateAnnexes: new UntypedFormControl(true),
    pointIds: new UntypedFormControl(null, Validators.required),
    typeSeanceId: new UntypedFormControl(null),
    targetSeanceId: new UntypedFormControl(null, Validators.required),
    message: new UntypedFormControl(null),
  });
  public seances = [];
  public globalElements: Global_Class = null;
  public types_seances_LV: Array<LabelValue> = [];
  public seanceId = null;
  seanceSelectedInfos: Partial<Meeting> = null;
  
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public api: ApiService,
    public IDelibeMeService: IDelibeMeService,
    public translater: TranslateService,
    public data: DataService,
    public spinner: NgxSpinnerService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    async.parallel(
      [
        (callback) => {
          this.data.getGlobalElements.subscribe((res: any) => {
            this.globalElements = new Global_Class(res);
            callback();
          });
        },
        (callback) => {
          this.seanceId = this.config.data.meetingId;
          const ids = [];
          const points = this.config.data.points;
          async.eachSeries(
            points,
            (point: any, next) => {
              ids.push(point.id);
              next();
            },
            () => {
              this.formReportPoint.patchValue({ pointIds: ids });
              callback();
            }
          );
        },
        (callback) => {
          this.IDelibeMeService.getRightsPointsSeances().subscribe((res: any) => {
            res.typeSeanceRights.forEach((x) => {
              if (x.addPoint) {
                this.globalElements.types_seances_LV.map((x) => x.value).indexOf(x.typeSeanceId) > -1
                  ? this.types_seances_LV.push(
                      this.globalElements.types_seances_LV[
                        this.globalElements.types_seances_LV.map((x) => x.value).indexOf(x.typeSeanceId)
                      ]
                    )
                  : null;
              }
            });
            this.types_seances_LV = _.sortBy(this.types_seances_LV, 'label');
            callback();
          });
        },
      ],
      () => {
        if(this.config.data.meeting) {
          this.formReportPoint.patchValue({ typeSeanceId: this.config.data.meeting.typeSeanceId });
          this.selectedMeetingPoint({ value: this.config.data.meeting.typeSeanceId });
        }
        this.spinner.hide();
      }
    );
  }

  selectedMeetingPoint(event):void {
    this.seanceSelectedInfos = null;
    if (event?.value) {
      const currentTypeSeanceRight = this.globalElements.rightsPointsSeances.typeSeanceRights.find(
        (x) => x.typeSeanceId === event.value
      );
      const data = {
        TypeSeanceIds: [this.formReportPoint.value.typeSeanceId],
        DateDebut: moment().format('YYYY-MM-DD'),
        Cloture: false,
        pageSize: 500,
      };
      if (currentTypeSeanceRight.isGestionnaire) {
        delete data.DateDebut;
      }
      this.api.getMeetingsSearch(data).subscribe((data: MeetingPaginated) => {
        this.seances = [];
        data.items.map((x: Meeting) => {
          const formattedDate = moment(x.date, 'YYYYMMDD').format(this.translater.translate('format.formatDateSeance'));
          const dateForOrdre = moment(x.date, 'YYYYMMDD').unix();
          this.seances.push({
            label: x.description
              ? x.description
              : this.translater.translate('seanceRemplaceDescriptionEmpty', { date: formattedDate }),
            value: x.id,
            date: dateForOrdre,
            verrouille: x.verrouille
          });
        });
      });
    }
  }

  clearTypeSeance(): void {
    this.formReportPoint.patchValue({ targetSeanceId: null });
    this.seanceSelectedInfos = null;
  }

  submitReport(): void {
    this.spinner.show();
    if (this.formReportPoint.valid) {
      const formToSend = {
        pointIds: this.formReportPoint.value.pointIds,
        targetSeanceId: this.formReportPoint.value.targetSeanceId,
        flagPointInRedaction: true,
        keepPointRedacteur: this.formReportPoint.value.keepPointRedacteur,
        duplicateAnnexes: this.formReportPoint.value.duplicateAnnexes,
        DuplicateContenuRTF: true,
        message: this.formReportPoint.value.message,
      };
      this.api.putReportPoints(this.seanceId, formToSend).subscribe(
        () => {
          this.formReportPoint.value.pointIds.length === 1
            ? this.toastr.success(this.translater.translate('success.reportedPoint'))
            : this.toastr.success(this.translater.translate('success.reportedPoints'));
          this.ref.close(true);
          this.spinner.hide();
        },
        (HttpErrorResponse) => {
          if (HttpErrorResponse.error.status === 400) {
            HttpErrorResponse.error.errors.forEach((err) => {
              this.toastr.error(err.message);
            });
          }
          this.spinner.hide();
        }
      );
    } else {
      this.spinner.hide();
      this.toastr.error(this.translater.translate('error.pleaseCompleteMandatoryFields'));
    }
  }

  displaySeanceSelected(): void {
    this.seanceSelectedInfos = this.seances.find((x) => x.value === this.formReportPoint.value.targetSeanceId);
  }
}
